import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
   <>
    <section className="page-banner">
        <div className="page-banner-container">
          <h2>Terms & Conditions</h2>
        </div>
      </section>
   
   
    <section className="terms-section">

      <div className="terms-container">

        {/* =========================
            PAGE HEADER
        ========================= */}

        <div className="terms-header">

          <span className="terms-label">
            Sai Shirdi Cab
          </span>

          <h1>
            Terms & Conditions
          </h1>

          <p>
            Please read the following terms and conditions carefully
            before booking a cab with Sai Shirdi Cab. These terms help
            ensure a safe, comfortable and reliable travel experience
            for every passenger.
          </p>

        </div>


        {/* =========================
            MAIN CONTENT
        ========================= */}

        <div className="terms-layout">


          {/* =========================
              IMAGE
          ========================= */}

          <div className="terms-image">

            <img
              src="/images/term.png"
              alt="Sai Shirdi Cab Service"
            />

            <div className="terms-image-overlay">

              <span>
                Safe • Reliable • Comfortable
              </span>

              <strong>
                Your Shirdi Journey, Our Responsibility
              </strong>

            </div>

          </div>


          {/* =========================
              TERMS CONTENT
          ========================= */}

          <div className="terms-content">


            {/* 1 */}

            <div className="terms-text-block">

              <h3>
                1. Booking Confirmation:
              </h3>

              <p>
                All Sai Shirdi Cab bookings are subject to vehicle
                availability. Booking confirmation will be provided
                after receiving the required customer details, travel
                date, pickup location, destination, vehicle preference,
                and confirmation from our team.
              </p>

            </div>


            {/* 2 */}

            <div className="terms-text-block">

              <h3>
                2. Travel Service Usage:
              </h3>

              <p>
                Sai Shirdi Cab provides cab services for Shirdi
                pilgrimage trips, Sai Baba Darshan, one-way journeys,
                round trips, pickup and drop services, family travel,
                and other transportation requirements. Customers must
                follow applicable travel rules and must not carry illegal,
                hazardous, or prohibited materials inside the vehicle.
              </p>

            </div>


            {/* 3 */}

            <div className="terms-text-block">

              <h3>
                3. Payment Policy:
              </h3>

              <p>
                Customers can make payments through cash, UPI, online
                payment, or bank transfer, depending on the available
                payment options. Advance payment may be required for
                certain vehicle bookings, round trips, peak-season
                bookings, or special travel arrangements.
              </p>

            </div>


            {/* 4 */}

            <div className="terms-text-block">

              <h3>
                4. Cancellation Policy:
              </h3>

              <p>
                Cancellation requests should be informed as early as
                possible before the scheduled journey. Cancellation
                charges may apply depending on the booking type, vehicle,
                travel date, and time of cancellation.
              </p>

            </div>


            {/* 5 */}

            <div className="terms-text-block">

              <h3>
                5. Customer Responsibility:
              </h3>

              <p>
                Customers must provide correct passenger details, pickup
                location, destination, contact information, travel date,
                and other booking requirements. Any additional charges
                resulting from incorrect information, changes in travel
                plans, customer delays, or additional stops may be payable
                by the customer.
              </p>

            </div>


            {/* 6 */}

            <div className="terms-text-block">

              <h3>
                6. Vehicle Capacity & Luggage:
              </h3>

              <p>
                Passengers must not exceed the permitted seating capacity
                of the booked vehicle. Luggage should remain within the
                vehicle's available capacity. Customers are responsible
                for their personal belongings, valuables, and luggage
                during the journey.
              </p>

            </div>


            {/* 7 */}

            <div className="terms-text-block">

              <h3>
                7. Driver & Travel Guidelines:
              </h3>

              <p>
                Our drivers are expected to follow applicable traffic and
                safety regulations while providing the cab service.
                Customers should cooperate with the driver and follow
                reasonable travel instructions. Additional driver charges
                may apply for extended trips, overnight travel, or
                additional requirements where applicable.
              </p>

            </div>


            {/* 8 */}

            <div className="terms-text-block">

              <h3>
                8. Safety Guidelines:
              </h3>

              <p>
                Passengers should follow all safety instructions and use
                seat belts where available. Smoking, consumption of
                alcohol, carrying illegal substances, or any activity
                that may compromise passenger or driver safety is not
                permitted inside the vehicle. Any damage to the vehicle
                caused by passengers may be chargeable.
              </p>

            </div>


            {/* 9 */}

            <div className="terms-text-block">

              <h3>
                9. Service Availability:
              </h3>

              <p>
                Sai Shirdi Cab reserves the right to modify, reschedule,
                replace, postpone, or refuse a service due to vehicle
                availability, road conditions, safety concerns, weather
                conditions, traffic restrictions, government regulations,
                breakdowns, or other unavoidable circumstances.
              </p>

            </div>


            {/* 10 */}

            <div className="terms-text-block">

              <h3>
                10. Jurisdiction:
              </h3>

              <p>
                Any dispute related to the services provided by Sai
                Shirdi Cab shall be subject to the applicable local laws
                and jurisdiction.
              </p>

            </div>


            {/* =========================
                TRAVEL & CAB POLICY
            ========================= */}

            <div className="terms-section-title">

              <h2>
                Travel & Cab Service Policy
              </h2>

            </div>


            <div className="terms-text-block">

              <h3>
                Sai Baba Darshan & Shirdi Pilgrimage Services:
              </h3>

              <p>
                Sai Shirdi Cab provides comfortable transportation for
                Sai Baba Darshan, Shirdi pilgrimage trips, family visits,
                one-way journeys, round trips, and return cab services.
                Customers are responsible for following the rules,
                timings, entry requirements, and instructions issued by
                the temple authorities.
              </p>

            </div>


            <div className="terms-text-block">

              <h3>
                One-Way & Round-Trip Cab Services:
              </h3>

              <p>
                Customers can book one-way or round-trip cab services
                according to their travel requirements. The pickup and
                drop locations, travel date, vehicle type, and other
                booking details should be confirmed before the journey.
              </p>

            </div>


            <div className="terms-text-block">

              <h3>
                Pickup & Drop Policy:
              </h3>

              <p>
                Customers should provide accurate pickup and drop-off
                locations while making the booking. Changes to the pickup
                or destination after confirmation may result in additional
                charges depending on the distance and travel requirements.
              </p>

            </div>


            <div className="terms-text-block">

              <h3>
                Toll, Parking & Additional Charges:
              </h3>

              <p>
                Toll charges, parking fees, interstate taxes, permits,
                entry charges, and other applicable travel expenses will
                be paid by the customer unless specifically included in
                the confirmed fare or package.
              </p>

            </div>


            <div className="terms-text-block">

              <h3>
                Waiting Charges:
              </h3>

              <p>
                Additional waiting charges may apply if the customer
                requests the driver to wait beyond the agreed pickup or
                scheduled waiting time. Applicable charges will depend
                on the booking and waiting duration.
              </p>

            </div>


            <div className="terms-text-block">

              <h3>
                Travel Time & Delays:
              </h3>

              <p>
                Estimated journey times may vary due to traffic, road
                conditions, weather, festivals, road closures, toll
                delays, traffic restrictions, or other circumstances
                beyond our control. Customers are advised to plan
                sufficient time for Sai Baba Darshan, train, bus, or
                flight schedules.
              </p>

            </div>


            {/* =========================
                REFUND POLICY
            ========================= */}

            <div className="terms-section-title">

              <h2>
                Refund Policy
              </h2>

            </div>


            <div className="terms-text-block">

              <h3>
                Refund Eligibility:
              </h3>

              <p>
                Refund eligibility depends on the booking type,
                cancellation timing, vehicle category, service conditions,
                and applicable cancellation charges. Refunds will be
                processed according to the applicable cancellation policy.
              </p>

            </div>


            <div className="terms-text-block">

              <h3>
                Refund Processing:
              </h3>

              <p>
                Approved refunds will be processed within 5–7 working
                days, subject to the payment method and applicable
                banking or payment gateway processing times.
              </p>

            </div>


            <div className="terms-text-block">

              <h3>
                No Show Policy:
              </h3>

              <p>
                No refund may be provided if the customer fails to arrive
                at the confirmed pickup location, cannot be contacted at
                the scheduled pickup time, or cancels the booking at the
                last moment.
              </p>

            </div>


            <div className="terms-text-block">

              <h3>
                Payment Confirmation:
              </h3>

              <p>
                Customers are advised to retain their payment receipt,
                transaction details, or booking confirmation until the
                completion of their journey.
              </p>

            </div>


          </div>

        </div>


        {/* =========================
            IMPORTANT NOTE
        ========================= */}

        <div className="terms-note">

          <div className="note-icon">
            !
          </div>

          <div>

            <h3>
              Important Note
            </h3>

            <p>
              By booking a Sai Shirdi Cab service, the customer confirms
              that they have read, understood, and agreed to these terms
              and conditions. Sai Shirdi Cab may update these terms when
              required to reflect changes in services, policies, or
              applicable regulations.
            </p>

          </div>

        </div>


        {/* =========================
            CTA
        ========================= */}

        <div className="terms-cta">

          <div>

            <span>
              Planning Your Shirdi Trip?
            </span>

            <h2>
              Book Your Sai Shirdi Cab Today
            </h2>

          </div>

          <a href="/contact-us">
            Contact Us
          </a>

        </div>


      </div>

    </section>
   </>
  );
};

export default TermsConditions;
